import { EndUserPages } from '@aurora/shared-types/pages/enums';
import React from 'react';
import BasePage from '../../../components/page/BasePage/BasePage';

/**
 * Forgot Password Page. Allows the user to request sending credentials recovery instructions to an email.
 *
 * @author Patricio Poratto
 */
const ForgotPasswordPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <BasePage
      pageId={EndUserPages.ForgotPasswordPage}
      nextSeoProps={{ noindex: true, nofollow: true }}
    />
  );
};
export default ForgotPasswordPage;
